import { ReelsEvents } from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import { ReelsModule } from '@gongxigames/framework/slot/modules/reels/ReelsModule';

export class FirecatcherReelsModule extends ReelsModule {

    protected _respinCount = 0;
    protected _prizeCountOnStoppedReels = 0;

    protected setupEvents(): void {
        super.setupEvents();

        this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onReelSpinningStarted);
        this.on(ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped);
    }

    protected onReelSpinningStarted(): void {
        this._prizeCountOnStoppedReels = this.prizeCount;
    }

    protected onAllReelsStopped(): void {
        this.respinsCount = this.logic.getFirecatcherRespinCount();
    }

    protected onFirecatcherWon(): void {
        this.respinsCount = this.logic.getFirecatcherRespinCount();
    }

    public get prizeCount(): number {
        return this.logic.getFirecatcherPrizeCount();
    }

    public get prizeCountOnStoppedReels(): number {
        return this._prizeCountOnStoppedReels;
    }

    public set respinsCount(value: number) {
        this._respinCount = value;
    }

    public get respinsCount(): number {
        return this._respinCount;
    }
}
